module.exports = __webpack_public_path__ + "img/fontUnderline.b6f28393.svg";